const getAlbums = async ( album, allAlbums, albumid) => {
    const requestOptions = {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({album, allAlbums, albumid,})
        
    }
    
    const response = await fetch('https://sharkuha.com/app/', requestOptions);
    const added = await response.json();
    return added ;}


const pressed = async (album, allAlbums, albumid) => {
    const requestOptions = {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({album, allAlbums, albumid})
        
    }
    
    const response = await fetch('https://sharkuha.com/app/', requestOptions);
    const added = await response.json();
    return added ;}

const getAllAlbums = async ( album, allAlbums, albumid, email, password) => {
    const requestOptions = {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({album, allAlbums, albumid, email, password})
        
    }
    
    const response = await fetch('https://sharkuha.com/app/', requestOptions);
    const added = await response.json();
    return added ;}
    
export default {
    
getAlbums,
pressed,
getAllAlbums



}
